import { EnvironmentI, VoucherI } from "./types";

export function sumProjectTemplates(projectTemplates: EnvironmentI[]): number {
  return projectTemplates.reduce(
    (acc, current) => current.price * current.quantity + acc,
    0
  );
}

export function getTotal(
  projectTemplatesToBuy: EnvironmentI[],
  voucher?: VoucherI,
  companyLabel = "ladecora"
): [number, number] {
  const fullTotal = sumProjectTemplates(projectTemplatesToBuy);

  let total = 0;
  const projectTemplatesCount = projectTemplatesToBuy.reduce(
    (acc, current) => current.quantity + acc,
    0
  );
  if (
    voucher &&
    voucher.code === "ZERACOMISSAOWL" &&
    companyLabel !== "tok_stok"
  ) {
    total = fullTotal;
  } else if (
    companyLabel !== "tok_stok" &&
    companyLabel !== "leroymerlinprojeta"
  ) {
    if (projectTemplatesCount === 1) {
      total = fullTotal;
    } else if (projectTemplatesCount === 2) {
      total = fullTotal * 0.9;
    } else {
      total = fullTotal * 0.85;
    }
  } else if (companyLabel === "tok_stok") {
    if (projectTemplatesCount === 1) {
      total = fullTotal;
    } else if (projectTemplatesCount === 2) {
      total = Math.floor(fullTotal * 0.92);
    } else {
      total = Math.floor(fullTotal * 0.88);
    }
  } else if (companyLabel === "leroymerlinprojeta") {
    if (projectTemplatesCount === 1) {
      total = fullTotal;
    } else if (projectTemplatesCount === 2) {
      total = Math.floor(fullTotal * 0.92);
    } else {
      total = Math.floor(fullTotal * 0.88);
    }
  }

  if (voucher && !voucher.amount && voucher.asGift) {
    return [fullTotal, 0];
  }

  if (voucher && voucher.amount) {
    let discountedTotal = 0;
    const voucherValue = voucher.amount;
    let discount = 0;
    if (voucher.typeValue === "fixed") {
      discount = total - voucherValue;
      if (discount > 0) {
        discountedTotal = discount;
      } else {
        discountedTotal = 0;
      }
    } else {
      discount = total * (voucherValue / 100);
      if (discount > 0) {
        discountedTotal = total - discount;
      }
    }

    return [fullTotal, discountedTotal];
  }
  return [fullTotal, total];
}
